<template>
  <svg-icon-component v-if="isSpinning" icon="spinner" class="spinning-icon" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SvgIconComponent from "@/components/shared/SvgIcon/SvgIcon.vue";
import { t } from "@/i18n";

/* used inline, like in a button */
/* we have 3 spinners: shared/Spinner.vue, shared/LoadingSpinner.vue, and shared/LoadingBox.vue */
export default defineComponent({
  name: "SpinnerComponent",
  components: {
    SvgIconComponent,
  },
  props: {
    isSpinning: {
      type: Boolean,
      default: false,
    },
  },
  methods: { t },
});
</script>

<style scoped lang="css">
@import "@/styles/variables.css";

svg {
  animation-name: spin;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
